module.exports = __webpack_public_path__ + "static/media/photo15.4794a9c7.jpg";